export default "__VITE_ASSET__6a0a504d__"